import * as PIXI from 'pixi.js-legacy';

import Room from './Room';
import tacHelpers from '../state/tac/tacHelpers';
import geometry from './util/geometry';
import {
  selectMinRoom,
  selectSceneMargins,
} from '../state/scene/sceneSelectors';
import store from '../state';
import { selectTac } from '../state/tac/tacSelectors';
import constants from '../settings/constants';

export default class DynamicRoom extends Room {
  update(args) {
    super.update(args);
    const minRoom = selectMinRoom(store.getState());
    const margins = selectSceneMargins(store.getState());
    const tac = selectTac(store.getState());

    // Margins cannot be bigger than the scene div
    margins.right = margins.right < this.targetWidth ? margins.right : 0;
    margins.top = margins.top < this.targetHeight ? margins.top : 0;

    const elementRatio =
      (this.targetWidth - margins.right) / (this.targetHeight - margins.top);
    this.model = tacHelpers.getRoom(tac, elementRatio, minRoom);

    this.ratio =
      (this.targetWidth - margins.right) / (this.model.width + this.leftDepth);

    this.floorHeight = this.bottomDepth * this.ratio;

    this.currentWall = this.getWallPxObject();

    this.draw({});
  }

  getSpace(tac) {
    return tacHelpers.getInitialSpace(tac);
  }

  /**
   * @returns {object[]} [{x, y}] in px
   */
  getWallPoints() {
    return this.getDefaultWallPoints();
  }

  /**
   * @param {number} wallHeight wall height in px
   * @param {number} wallWidth wall width in px
   */
  getWallPosition({ wallHeight, wallWidth }) {
    return {
      y: 0,
      x: 0,
    };
  }

  getWallPxObject() {
    const points = this.getWallPoints();
    const { width, height } = geometry.surround(points);
    const position = this.getWallPosition({
      wallWidth: width,
      wallHeight: height,
    });

    return { points, width, height, position };
  }

  fillWall(ctx, points) {
    ctx.fillRect(0, 0, this.targetWidth, this.targetHeight);
  }

  drawWall() {
    this.gradientBaseTexture =
      this.gradientBaseTexture ||
      new PIXI.BaseTexture(
        this.createGradientCanvas({
          angle: constants.WALL_GRADIENT_ANGLE,
          lightColor: constants.GRADIENT_LIGHT_COLOR,
          darkColor: constants.GRADIENT_DARK_COLOR,
        })
      );

    this.wallTexture =
      this.wallTexture || new PIXI.Texture(this.gradientBaseTexture);
    this.wallSprite = this.wallSprite || new PIXI.Sprite(this.wallTexture);
    this.wallMask = this.wallMask || new PIXI.Graphics();
    this.wall = this.wall || new PIXI.Container();

    const { currentWall, gradientBaseTexture, wall, wallSprite } = this;

    gradientBaseTexture.setSize(currentWall.width, currentWall.height);
    wallSprite.position.set(currentWall.position.x, currentWall.position.y);

    wall.x = currentWall.position.x;
    wall.y = currentWall.position.y;

    !wall.parent && this.addChild(wall);
    !wallSprite.parent && this.addChild(wallSprite);
  }

  drawFloor(bottomPadding = 0) {
    const width = this.currentWall.width;
    const texture = PIXI.Loader.shared.resources.floor.texture;
    this.floor = this.floor || new PIXI.Sprite(texture);

    const { floor } = this;

    floor.width = width;
    floor.height = this.floorHeight;
    floor.x = (this.targetWidth - this.currentWall.width) / 2;
    floor.y = this.targetHeight - floor.height - bottomPadding;

    if (!floor.parent) {
      this.addChild(floor);
    }
  }
}
